import ReportWrapper from '../ReportWrapper'
import React from 'react'
import CourtCasesOverview from './CourtCasesOverview'
import RelatedCasesStatistics from './RelatedCasesStatistics'
import CriminalCases from './CriminalCases'
import CivilCases from './CivilCases'
import OtherCases from './OtherCases'
import ReportSectionHeading from '../ReportSectionHeading'

interface CourtCasesProps {
  data: any
  title: string
  sectionIndex?: string
}

export default function CourtCases({ data, title, sectionIndex }: CourtCasesProps) {
  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <CourtCasesOverview data={data} />
      <RelatedCasesStatistics data={data} />
      <CriminalCases data={data} />
      <CivilCases data={data} />
      <OtherCases data={data} />
    </ReportWrapper>
  )
}
